// Cookie Policy - Estonian version

export const cookieContentET = {
  title: 'Küpsiste poliitika',
  lastUpdated: 'Viimati uuendatud: 06.11.2025',
  
  sections: [
    {
      id: 'what-are-cookies',
      title: '1. Mis on küpsised?',
      content: 'Küpsised on väikesed tekstifailid, mida veebisaidid salvestavad teie seadmesse kasutajakogemuse parandamiseks ja veebi liikluse analüüsimiseks. Küpsised ei kahjusta teie seadet ega sisalda viirusi.'
    },
    {
      id: 'types',
      title: '2. Milliseid küpsiseid me kasutame?',
      types: [
        {
          name: 'Vajalikud küpsised',
          description: 'Need küpsised on vajalikud veebisaidi tööks ega saa neid keelata.',
          items: ['Seansi haldamine', 'Turvalisus ja autentimine', 'Vormide andmete salvestamine'],
          retention: 'Seansi lõpuni'
        },
        {
          name: 'Analüütilised küpsised',
          description: 'Aitavad meil mõista, kuidas külastajad saiti kasutavad.',
          items: [
            { name: 'Google Analytics 4', description: 'Liikluse ja kasutajate käitumise analüüs' },
            { name: 'Hotjar', description: 'Kasutajakogemuse analüüs ja soojuskaardid' }
          ],
          retention: 'Kuni 2 aastat',
          privacy: 'https://policies.google.com/privacy'
        },
        {
          name: 'Turunduslikud küpsised',
          description: 'Kasutatakse sihitud reklaami ja reamarketingu jaoks.',
          items: [
            { name: 'Facebook Pixel', description: 'Reklaami optimeerimine ja reamarketing' }
          ],
          retention: 'Kuni 2 aastat',
          privacy: 'https://www.facebook.com/privacy/policy'
        },
        {
          name: 'Funktsionaalsed küpsised',
          description: 'Pakuvad täiustatud funktsioone ja isikupärastamist.',
          items: [
            { name: 'ChatGPT vidin', description: 'AI-assistent' },
            'Keele ja eelistuste salvestamine'
          ],
          retention: 'Kuni 1 aasta'
        }
      ]
    },
    {
      id: 'manage',
      title: '3. Kuidas küpsiseid hallata?',
      content: 'Küpsiseid saate hallata meie sätete või oma brauseri sätete kaudu. Pange tähele, et küpsiste keelamine võib mõjutada veebisaidi funktsionaalsust.',
      buttonText: 'Ava küpsiste sätted'
    },
    {
      id: 'legal',
      title: '4. Õiguslik alus',
      intro: 'Küpsiste kasutamine põhineb:',
      items: [
        'Üldine andmekaitseMäärus (GDPR)',
        'Eesti elektroonilise side seadus § 104',
        'Teie nõusolek (välja arvatud vajalikud küpsised)'
      ]
    },
    {
      id: 'contact',
      title: '5. Kontakt',
      intro: 'Küpsistega seotud küsimuste korral võtke meiega ühendust:',
      company: 'Polyus Plus OÜ',
      address: 'Uuslinna 11, Tallinn, Estonia',
      linkText: 'Võta ühendust kontaktvormi kaudu'
    }
  ]
};
